import { render, staticRenderFns } from "./medicine.vue?vue&type=template&id=2e726b18&scoped=true&"
import script from "./medicine.vue?vue&type=script&lang=js&"
export * from "./medicine.vue?vue&type=script&lang=js&"
import style0 from "./medicine.vue?vue&type=style&index=0&id=2e726b18&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e726b18",
  null
  
)

export default component.exports